import { useNavigate, useParams } from "react-router";
import { z } from "zod";
import styles from "./DailyOverview.module.scss";
import {
  BackButton,
  CloseButton,
} from "@/components/NavigationButtons/NavigationButtons";
import { ActivityOccurrence } from "../Patient/Activities/ActivityOccurrence/ActivityOccurrence";

export const ActivityInDailyOverview = () => {
  const { activityId, occurrenceId } = z
    .object({
      activityId: z.string(),
      occurrenceId: z.string(),
    })
    .parse(useParams());
  const navigate = useNavigate();

  return (
    <div className={styles.activityOccurrenceOrGroup}>
      <ActivityOccurrence
        activityId={activityId}
        occurrenceId={occurrenceId}
        closeActivityOccurrencePanel={() => navigate("../..")}
        navigationButtonsInHeader={{
          backButton: <BackButton navigateBack={() => navigate("..")} />,
          closeButton: <CloseButton close={() => navigate("../..")} />,
        }}
      />
    </div>
  );
};
